export const getLocale = () => {
  // detect language and only get language code before the first dash
  const localeDetected = navigator.language.substring(
    0,
    navigator.language.indexOf('-')
  )

  // set locale. Default to de
  return ['de', 'en', 'fr'].includes(localeDetected) ? localeDetected : 'de'
}
